import ENV from "react-dotenv";


export type APPLICATION_API_DATA_TYPE = {
    API_ROOT_URL: string | null
};


export const APPLICATION_API_DATA:APPLICATION_API_DATA_TYPE = {
    API_ROOT_URL: ENV?.API_URL || null
};


export default APPLICATION_API_DATA;
